import { post, get } from './api';
import { API_ENDPOINTS } from '@utils/constants';

/**
 * Membership Service
 * Handles all membership-related API calls
 */

/**
 * Submit membership application
 * @param {object} data - Membership application data
 * @returns {Promise} Response
 */
export const submitMembershipApplication = async (data) => {
  try {
    const response = await post(API_ENDPOINTS.membership, data);
    return response;
  } catch (error) {
    console.error('Error submitting membership application:', error);
    throw error;
  }
};

/**
 * Get membership benefits
 * @returns {Promise} Membership benefits
 */
export const getMembershipBenefits = async () => {
  try {
    const response = await get(`${API_ENDPOINTS.membership}/benefits`);
    return response;
  } catch (error) {
    console.error('Error fetching membership benefits:', error);
    throw error;
  }
};

/**
 * Get membership tiers
 * @returns {Promise} Membership tiers
 */
export const getMembershipTiers = async () => {
  try {
    const response = await get(`${API_ENDPOINTS.membership}/tiers`);
    return response;
  } catch (error) {
    console.error('Error fetching membership tiers:', error);
    throw error;
  }
};

export default {
  submitMembershipApplication,
  getMembershipBenefits,
  getMembershipTiers,
};